import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(regionId, engineerId, startDate) {
  return yield oncallFetch("/api/oncall/partners/shifts-definitions/add", {
    regionId,
    engineerId,
    startDate,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/shifts-definitions/add.js